import { Observable, catchError, switchMap, throwError } from "rxjs";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalstorageService } from '@gridscale/gs-services/localstorage.service';
import { ConfigService } from '@gridscale/ingrid/helper/services/config.service';
import { environment } from '../../../environments/environment';
import { GitlabApiAuthService } from '../gitlab-api/gitlab-api-auth.service';

@Injectable()
export class GsHttpInterceptor implements HttpInterceptor {
  readonly #configService = inject(ConfigService);
  #gitlabRefreshing = false;

  constructor(private readonly localStorage: LocalstorageService, private readonly gitlabAuthService: GitlabApiAuthService) { }


  #handleGitlabRefresh(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.#gitlabRefreshing) {
      this.#gitlabRefreshing = true;

      if (this.gitlabAuthService.isAuthenticated) {
        return this.gitlabAuthService.refreshToken().pipe(
          switchMap(() => {
            this.#gitlabRefreshing = false;

            return this.#setGitlabTokenHeader(request, next);
          }),
          catchError(e => {
            this.#gitlabRefreshing = false;

            return throwError(() => e);
          })
        )
      }
    }

    return next.handle(request);
  }

  #setGitlabTokenHeader(request: HttpRequest<any>, next: HttpHandler) {
    const req = request.clone({
      headers: request.headers.set('Authorization', 'Bearer ' + this.gitlabAuthService.accessToken)
    });

    return next.handle(req);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('git.gridscale.it')) {
      const isExpired = this.gitlabAuthService.isTokenExpired();

      if (!isExpired) {
        return this.#setGitlabTokenHeader(request, next);
      } else {
        return this.#handleGitlabRefresh(request, next);
      }
    } else {
      if (this.localStorage.getItem('gs_pp_auth')) {
        try {
          const credentials = JSON.parse(
            this.localStorage.getItem('gs_pp_auth', '{}') as string
          );

          if (
            request &&
            request.url &&
            (request.url.search('igstatic') !== -1 ||
              request.url.search('statuspal') !== -1 ||
              request.url.search('environment.api_status') !== -1)
          ) {
            // DO NOT JOB
          } else {
            request = request.clone({
              setHeaders: {
                'x-auth-token': credentials.token,
                'x-auth-userId': credentials.user_uuid,
              },
            });
          }
        } catch (e) {
          console.error(e);
        }
      }

      if (environment.useCorsProxy && environment.corsProxyUrl) {
        const proxyUrl = environment.corsProxyUrl.replace(/\/?$/, '/');

        if (request.url.indexOf(proxyUrl) !== 0 && (request.url.indexOf(this.#configService.partnerApi) === 0 || request.url.indexOf(this.#configService.partnerLegacyApi) === 0 || request.url.indexOf(this.#configService.coreAPI) === 0 || request.url.indexOf('/maja/') >= 0)) {
          request = request.clone({
            url: proxyUrl + request.url
          })
        }
      }

      return next.handle(request);
    }
  }
}
